import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/Avis.css';
import api from '../apiService/api';


// const API_URL = "https://api.kasbah-magic.com/conciergeLastVersion/index.php?action=read_testimonies";
// const BASE_URL = "https://api.kasbah-magic.com/conciergeLastVersion/"; // Add this to prepend to image paths
const API_URL = api.API_URL+ "read_testimonies";
const BASE_URL = api.BASE_URL;

const Avis = () => {
  const { t } = useTranslation();
  const [testimonials, setTestimonials] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Fetch testimonials from backend
  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await fetch(API_URL);
        const data = await response.json();
        if (data.success) {
          // Ensure image URLs are correctly formatted
          const updatedTestimonies = data.testimonies.map(testimony => ({
            ...testimony,
            image_url: BASE_URL + testimony.image_url, // Append base URL
          }));
          setTestimonials(updatedTestimonies);
        } else {
          console.error("Failed to fetch testimonials:", data.message);
        }
      } catch (error) {
        console.error("Error fetching testimonials:", error);
      }
    };

    fetchTestimonials();
  }, []);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <div className="avis-container">
      <div className='avis-div'>
        <h2 className="avis-title">
          {t("customerReviewsTitle").split("|").map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </h2>

        <div className="avis-nav">
          <button className="Avnav-btn" onClick={prevSlide}>←</button>
          <button className="Avnav-btn" onClick={nextSlide}>→</button>
        </div>
      </div>

      {testimonials.length > 0 ? (
        <div className="avis-content">
          <div className="avis-images">
            <img src={testimonials[currentIndex].image_url} alt="Testimonial" className="avis-image" />
            <div className="avis-text">
            
            <div className="testimonial">
  <h3 className="avis-name">{testimonials[currentIndex].name}</h3>
  <h4 className="avis-location">{testimonials[currentIndex].location}</h4>


            <p>{testimonials[currentIndex].content}</p>
          </div>
          </div>
          
         
        </div>
        </div>
      ) : (
        <p className="loading-message"></p>
      )}
    </div>
  );
};

export default Avis;
